import { useAxiosPrivate } from "./axios";

const LIST_QUERY = "/onsiteserviceworksheet/list";
const GET_QUERY = "/onsiteserviceworksheet/get";
const CONFIRM_QUERY = "/onsiteserviceworksheet/confirm";

export const useSearchServiceWorksheet = () => {
  const searchServiceWorksheet = async (params, callback) => {
    const getUrlSearchParams = (params) => {
      const searchParam = {
        offset: params.offset,
        limit: params.limit,
      };
      if (params.status !== null) {
        searchParam.status = params.status;
      }
      return searchParam;
    };

    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        params: getUrlSearchParams(params),
        paramsSerializer: {
          indexes: null,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchServiceWorksheet;
};

export const useGetServiceWorksheet = () => {
  const getServiceWorksheet = async (id, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(GET_QUERY, {
        params: {
          id: id,
        },
        paramsSerializer: {
          indexes: null,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return getServiceWorksheet;
};

export const useConfirm = () => {
  const confirm = async (swId, email, customer, callback) => {
    try {
      const controller = new AbortController();

      const param = {
        swId: swId,
        customer: customer,
        email: email,
      };
      const response = await axiosPrivate.put(CONFIRM_QUERY, param, {
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return confirm;
};
